export interface ISessionForm{
    title: string,
    date: Date,
    timeFrom: Date,
    timeTo: Date,
    selectedClient: string
}

export type ISessionErrors = Partial<Record<keyof ISessionForm, string>>;
export const addSessionValidate = (data: ISessionForm): {errors: ISessionErrors, isValid: boolean} =>{
    const errors: ISessionErrors = {};
    let isValid = true;
    if (!data.date){
        errors.date = 'validation_enter_date';
        isValid = false;
    }

    if (!data.timeFrom){
        errors.timeFrom = 'validation_enter_start_time';
        isValid = false;
    }

    if (!data.timeTo){
        errors.timeTo = 'validation_enter_end_time';
        isValid = false;
    }
    
    return {errors, isValid}
}